// eslint-disable-next-line no-restricted-imports
import {css} from '@emotion/css'
import styled from '@emotion/styled'
import {motion} from 'motion/react'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'
import mirror from '@vio/atlas/src/utils/mirror'
import {cssTheme} from '@vio/atlas/themes'

import {DOT_WIDTH} from './constant'

// Slide
export const Pinchable = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`

// VirtualizedGallery
export const VirtualizedGalleryWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${cssTheme.colors.background.neutral.inversePrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const SliderWrapper = styled.div`
  height: 100%;
`

export const SlideNumberWrapper = styled.div`
  position: absolute;
  bottom: ${cssTheme.layout.spacing.s400};
  right: ${cssTheme.layout.spacing.s500};
  color: ${cssTheme.colors.content.neutral.inverse};
  z-index: 1;
`

// PaginationButtons
export const ButtonsWrapper = styled(motion.div)`
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BackwardButton = styled(Button)`
  margin: 0 ${cssTheme.layout.spacing.s300};
  position: absolute;
  left: 0;
  html[dir='rtl'] & {
    right: 0;
  }
`
export const ForwardButton = styled(Button)`
  margin: 0 ${cssTheme.layout.spacing.s300};
  position: absolute;
  right: 0;
  html[dir='rtl'] & {
    left: 0;
  }
`

export const IconComponent = styled(Icon)`
  ${mirror()}
`

// CurrentSlideIndicators
export const IndicatorWrapper = styled.div`
  position: absolute;
  height: 44px;
  bottom: 0;
  left: 50%;
  width: 100%;
  z-index: 1;
  display: flex;
  transform: translateX(-50%);
  align-items: center;
  justify-content: center;
`

export const DotIndicator = styled(motion.div)`
  width: ${DOT_WIDTH}px;
  height: ${DOT_WIDTH}px;
  background-color: ${cssTheme.colors.background.neutral.primary};
  border-radius: 50%;
`

// LightboxGalleryMobile
export const backgroundColorStyles = css`
  background: ${cssTheme.colors.background.neutral.inversePrimary};
`

export const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const GalleryWrapper = styled.div`
  flex-grow: 1;
`

export const Footer = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`
